import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../common/FormUtils';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../common/FormModal';
import FeedbackService from './FeedbackService';
import DirectoryService from '../directory/DirectoryService';
import schema from './feedbackSchema';
const jsonSchema = schema;
const mergedJsonSchema = (jsonSchema, users) => {
  const reviewerList = users;
  return jsonSchema.map(field => {
    if (field.name === 'employee') {
      return {
        ...field,
        options: reviewerList
      };
    }
    if (field.name === 'reviewer') {
      console.log(field.name);
      return {
        ...field,
        options: reviewerList
      };
    }
    return field;
  });
};
const FeedbackForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [users, setUsers] = useState();

  useEffect(() => {
    const fetchData = async () => {
      if (undefined !== identifier) {
        FeedbackService.retrieveFeedback(identifier)
          .then(data => {
            const updatedData = {
              ...data,
              employee: {
                label: data.employee.firstName + ' ' + data.employee.lastName,
                value: data.employee.identifier
              },
              reviewer: {
                label: data.reviewer.firstName + ' ' + data.reviewer.lastName,
                value: data.reviewer.identifier
              }
            };
            setData(updatedData);
          })
          .catch(error => console.log(error));
      }
      const usersByAccount = await DirectoryService.retrieveUsersByAccount();
      const mappedUsers = usersByAccount.map(u => ({
        value: u.identifier,
        label: u.firstName + ' ' + u.lastName
      }));
      setUsers(mappedUsers);
    };
    fetchData();
  }, [identifier]);
  const handleFeedbackFormSubmit = formData => {
    console.log('Feedback form submitted:', formData);
    FeedbackService.saveFeedback(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Feedback',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Feedback');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const title = undefined === identifier ? 'Create Feedback' : 'Complete Feedback';
  const headerGenerated = useHeaderGenerator(
    title,
    ' ',
    buttonsConf
  );

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Feedback  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/performance"
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleFeedbackFormSubmit}
              users={users}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit, users }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit } = useFormGenerator(
    mergedJsonSchema(jsonSchema, users),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};

FormGeneratorWithData.propTypes = {
  buttonsConf: PropTypes.any,
  data: PropTypes.any,
  onSubmit: PropTypes.any,
  users: PropTypes.any
};
export default FeedbackForm;
